/**
 * Player store
 * Saves local data
 * */
export class Storage {
  constructor(storageLocation) {
    this.storageLocation = storageLocation;

    this._getQuestionsFromStore();

    return this;
  }

  /**
   * Get questions
   * */
  getQuestions() {
    return this._getQuestionsFromStore();
  }

  /**
   * Checks is question already has an answer
   * @param {string} reference The question reference
   * */
  questionExists(reference) {
    return this.questions.includes(reference);
  }

  /**
   * Add current question to store
   * @param {string} reference The question reference
   * */
  addQuestion(reference) {
    this.questions.push(reference);

    this._saveQuestionsToStore();
  }

  /*
   * Remove question from store
   * @param {string} reference The question reference
   * */
  removeQuestion(reference) {
    const index = this.questions.indexOf(reference);
    if (index >= 0) {
      this.questions.splice(index, 1);

      this._saveQuestionsToStore();
    }
  }

  /**
   * Clears user local saved settings
   * */
  clear() {
    this._clearStore();
  }

  /**
   * Save questions to store
   * */
  _saveQuestionsToStore() {
    window.localStorage.setItem(
      this.storageLocation,
      JSON.stringify(this.questions),
    );
  }

  /**
   * Get questions from store
   * */
  _getQuestionsFromStore() {
    const questionsString = window.localStorage.getItem(this.storageLocation);
    this.questions = (questionsString && JSON.parse(questionsString)) || [];
    return this.questions;
  }

  /**
   * Clear store
   * */
  _clearStore() {
    window.localStorage.removeItem(this.storageLocation);
    this.questions = [];
  }
}
